import React from 'react'
import Simple from 'layouts/simple'
import Banner from './components/Banner'
import InfoProdutos from './components/InfoProdutos'
import Atencao from './components/Atencao'
import RiberPerto from './components/RiberPerto'
import Credibilidade from './components/Credibilidade'
import ComparativoTaxas from './components/ComparativoTaxas'
import PassoAPasso from './components/PassoAPasso'

const LandingPage = () => {
  return (
    <Simple>
      <Banner />
      <InfoProdutos />
      <PassoAPasso />
      <ComparativoTaxas />
      <Credibilidade />
      <Atencao />
      <RiberPerto />
    </Simple>
  )
}

export default LandingPage
